import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { PdpSharedBlurbDesignYourOwn_item$key } from './__generated__/PdpSharedBlurbDesignYourOwn_item.graphql';
import { PdpSharedBlurbDesignYourOwn_viewer$key } from './__generated__/PdpSharedBlurbDesignYourOwn_viewer.graphql';

// components
import StoneCutRadiant from 'dibs-icons/exports/StoneCutRadiant';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';

// helpers
import { dyoDetail, dyoTitle } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpSharedBlurbDesignYourOwn.scss';

type Props = {
    item: PdpSharedBlurbDesignYourOwn_item$key;
    viewer: PdpSharedBlurbDesignYourOwn_viewer$key;
};

export const PdpSharedBlurbDesignYourOwn: FC<Props> = ({ item: itemRef, viewer: viewerRef }) => {
    const viewer = useFragment(
        graphql`
            fragment PdpSharedBlurbDesignYourOwn_viewer on Viewer {
                isDyoEnabled: featureFlag(feature: "designYourOwn")
            }
        `,
        viewerRef
    );

    const item = useFragment(
        graphql`
            fragment PdpSharedBlurbDesignYourOwn_item on Item {
                isDyoCustomizable
            }
        `,
        itemRef
    );

    const showDyoVersion = viewer?.isDyoEnabled && item?.isDyoCustomizable;

    if (!showDyoVersion) {
        return null;
    }

    return (
        <>
            <PdpSharedBlurb IconComponent={StoneCutRadiant} iconClass={styles.blurbIcon}>
                <span className={styles.blurbTitle}>{dyoTitle}</span>
                <span className={styles.blurbDetail}>{dyoDetail}</span>
            </PdpSharedBlurb>
        </>
    );
};
